import(/* webpackMode: "eager" */ "/app/src/app/ai-scans/announcements/page.tsx");
